import { EmptyState, PageHeader } from '@aigovops/design-system';

/**
 * /o/:orgSlug/vendor-attestations — Placeholder for aggregated vendor
 * attestation tracking across all child workspaces.
 *
 * NAV-4-4: Wired into the org sidebar so the navigation is complete.
 * Full implementation (attestation rollup, per-workspace breakdown,
 * timeline view) lands in a later phase.
 */
export function OrgVendorAttestations() {
  return (
    <div style={{ display: 'grid', gap: 'var(--space-4)' }}>
      <PageHeader
        title="Vendor Attestations"
        subtitle="Aggregated vendor attestation tracking across all workspaces."
      />
      <EmptyState
        title="Vendor Attestations"
        description="Aggregated vendor attestation tracking is coming soon. Workspace-level attestations are available in each workspace's Third-Party Risk section."
      />
    </div>
  );
}
